<svg
  width="21"
  height="14"
  viewBox="0 0 21 14"
  fill="none"
  class={$$restProps.class}
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M1.41045 14C1.00995 14 0.674751 13.8651 0.404851 13.5951C0.13495 13.3252 0 12.9901 0 12.5896V1.56716C0 1.16667 0.16107 0.805348 0.483209 0.483209C0.805348 0.16107 1.16667 0 1.56716 0H6.45149L8.54104 2.08955H16.6119C16.908 2.08955 17.1692 2.15485 17.3955 2.28545C17.6219 2.41604 17.8047 2.59453 17.944 2.8209H8.25373L6.16418 0.731343H1.56716C1.32338 0.731343 1.12313 0.809702 0.966418 0.966418C0.809701 1.12313 0.731343 1.32338 0.731343 1.56716V12.4328C0.731343 12.6244 0.779229 12.7811 0.875 12.903C0.970771 13.0249 1.09701 13.1294 1.25373 13.2164L3.57836 5.43284H20.2425L17.9701 13.0075C17.8831 13.3035 17.7133 13.5429 17.4608 13.7257C17.2083 13.9086 16.9254 14 16.6119 14H1.41045ZM2.01119 13.2687H17.1343L19.25 6.16418H4.12687L2.01119 13.2687Z"
    fill="#1C1C20"
  />
</svg>



